module.exports = __webpack_public_path__ + "img/ResidentSupervise4.c30b71fe.png";